import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { DashboardModule } from './dashboard/dashboard.module';
import { HttpClientModule } from '@angular/common/http';
// import { AuthModule } from './auth/auth.module';
import { PrivacyPolicyComponent } from './shared/components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './shared/components/terms-and-conditions/terms-and-conditions.component';

export const routes: Routes = [
  { path: '', loadChildren:() => import('./auth/auth.module').then(d => d.AuthModule)},
  { path: 'login', loadChildren:() => import('./auth/auth.module').then(d => d.AuthModule)},
  { path: 'forget-password', loadChildren:() => import('./auth/auth.module').then(d => d.AuthModule)},  
  { path: 'reset-password', loadChildren:() => import('./auth/auth.module').then(d => d.AuthModule)},  
   //{ path: 'register-profile', loadChildren:() => import('./auth/auth.module').then(d => d.AuthModule)},  
  // { path: 'register-profile1', loadChildren:() => import('./auth/auth.module').then(d => d.AuthModule)},
  { path: 'registration-status', loadChildren:() => import('./auth/auth.module').then(d => d.AuthModule)},    
  
  { path: 'dashboard', loadChildren:() => import('./dashboard/dashboard.module').then(d => d.DashboardModule)},
  { path: 'dashboard/admin', loadChildren:() => import('./dashboard/dashboard.module').then(d => d.DashboardModule)},
  
  { path: 'users', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  { path: 'users/create-user', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  { path: 'users/user-search', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  { path: 'users/import-user', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  { path: 'users/vendor-search', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  { path: 'users/user-permissions', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  { path: 'users/vendor-edit', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  { path: 'users/vendor-edit-old', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  { path: 'users/vendor-individual-edit', loadChildren:() => import('./users/users.module').then(d => d.UsersModule)},
  
  { path: 'admin', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/lookup-category', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/lookup-master', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/country', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/state', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/city', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/claims-master', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/application-features', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/user-claims', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/user-role-default-features', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/userapproval-search', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/client-requisition-contact', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},
  { path: 'admin/rate-change-request', loadChildren:() => import('./admin/admin.module').then(d => d.AdminModule)},


  { path: 'applicant', loadChildren:() => import('./applicant/applicant.module').then(d => d.ApplicantModule)},
  { path: 'applicant/applicant-add', loadChildren:() => import('./applicant/applicant.module').then(d => d.ApplicantModule)},
  { path: 'applicant/applicant-list', loadChildren:() => import('./applicant/applicant.module').then(d => d.ApplicantModule)},
  { path: 'applicant/applicant-view', loadChildren:() => import('./applicant/applicant.module').then(d => d.ApplicantModule)},
  { path: 'applicant/applicant-search', loadChildren:() => import('./applicant/applicant.module').then(d => d.ApplicantModule)},

  { path: 'requisition', loadChildren:() => import('./requisition/requisition.module').then(d => d.RequisitionModule)},
  { path: 'requisition/submission', loadChildren:() => import('./requisition/requisition.module').then(d => d.RequisitionModule)},

  { path: 'invoice', loadChildren:() => import('./invoice/invoice.module').then(d => d.InvoiceModule)},
  { path: 'invoice/vendor', loadChildren:() => import('./invoice/invoice.module').then(d => d.InvoiceModule)},

  { path: 'report', loadChildren:() => import('./report/report.module').then(d => d.ReportModule)},
  { path: 'report/vendor-activity', loadChildren:() => import('./report/report.module').then(d => d.ReportModule)},
  { path: 'vendor-onboarding', loadChildren:() => import('./vendor-onboarding/vendor-onboarding.module').then(d => d.VendorOnboardingModule)},
  { path: 'vendor-onboarding/companyprofile-onboarddocument', loadChildren:() => import('./vendor-onboarding/vendor-onboarding.module').then(d => d.VendorOnboardingModule)},
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
];

@NgModule({
  imports: [
    HttpClientModule,
    RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
